/* Add table level Reminders and Notifications Apr 29, 2023 */
/* Amend created() to test for contextId >0, add scoped to Style Oct 21, 2023 */
/* Amend comment !this.d_contextId,add reminderOptionId to fn_saveData, remove if(!this.d_contextId) Nov 11, 2023*/
<template lang="pug">
	div(class="kt-reminder-opts")
		div(class="reminder-opts-header") Reminders and Notifications for {{c_appEntName}}
		div(v-if="c_eventOpts.length==0")
			span(style="border: none;") No Reminders and Notifications Options
		div(v-else class="reminder-opt-grp p-1 mx-1 border border-dark" )
				span(class="lbl") Remind Me
				div(class="reminder-opts d-flex flex-wrap flex-row mx-0" :class="{'mb-1': `${d_eventOpts.length - 1 !== eix}`}" v-for="(evnt, eix) in c_eventOpts" :key="evnt.triggerKey+eix")
					div(class="flex-grow-1")
						input(v-if="evnt.daysBefore >=0" class="mr-1" style="width:15%;" type="number" min=0 max=90 v-model="evnt.daysBefore" :disabled="evnt.disabled")
						span(style="font-size:12.5px;") {{evnt.lbl}}
					div(style="display:flex;")
						span(class="kbdp mr-2" title="Remind me" :class="evnt.kbdp?'selected':null" @click="m_clickKbdp(eix)")
							fa-layers
								fa-icon(:icon="evnt.kbdp ? ['fas', 'bell']:['far','bell-slash']")
								fa-icon(:icon="['fas', 'check']" transform="up-2 right-2" v-show="evnt.kbdp")
						span(class="email" title="Send Email" :class="evnt.email?'selected':null" 	@click="m_clickEmail(eix)")
							fa-layers
								fa-icon(:icon="['fas', 'envelope']" transform="grow-4")
								fa-icon(:icon="['fas', 'check']" transform="up-5 right-5" v-show="evnt.email")
		<hr>
		div(class="reminder-opts-footer")
			b-button(variant="primary" title="Save" :disabled="c_opts" @click="m_save()" ) Save
			b-button(variant="outline-secondary" title="Close" @click="m_close()") Close
			kt-tt-info(p_infoTxt="To reinstate a reminder that was previously dismissed, toggle off the reminder (Save), \
			then toggle it back on (Save). Changing the “# of day(s) before” option also reinstates a dismissed reminder.")

</template>
<script>
import {fn_getReminderOptions,fn_saveReminderOptions} from "@/utils/api.js";
import {kbdpAlert} from "@/utils/util.js";
import {userSettings} from "@/utils/ref-data.js";
import { eventBus } from '@/main';
export default {
  name: "kt-reminder-opts",
  components: {},
  created() {
	
	let opprDD = {
		targetKey:'teamMember',
		lbl: 'Opportunity Due Date',
		triggerKey: 'opprDD',
		daysBefore: 1,
		disableReminder: false,
		disableEmail: true,
		enabled:true,
		email:null,
		kbdp:null,
	};
	let opprSWTD = {
		targetKey:'teamMember',
		lbl: 'Site Walk Through Date',
		triggerKey: 'opprSWTD',
		daysBefore: 1,
		disableReminder: false,
		disableEmail: true,
		enabled:true,
		email:null,
		kbdp:null,
	};
	
	let taskDD = {
	targetKey:'teamMember',
    lbl: "day(s) before Activity Due Date",
    triggerKey: "taskDD",
    daysBefore: 1,
	disableReminder: false,
    disableEmail: true,
	enabled:true,
	email:null,
	kbdp:null,
  };

  let taskAssigned = {
    targetKey:'teamMember',
    lbl: "When Activity is assigned",
    triggerKey: "taskAssigned",
    disableReminder: true,
	disableEmail: false,
	enabled:true,
	email:null,
	kbdp:null,
  };

  switch (this.p_appEnt.key) {
    case "oppr":
		this.d_eventOpts = [opprDD,opprSWTD,taskDD, taskAssigned];
		this.d_context = this.p_appEnt.idKey;
		this.d_contextId = this.p_recData[this.p_appEnt.idKey];
      break;
    case "proj":
		this.d_eventOpts = [taskDD, taskAssigned];
		this.d_context = this.p_appEnt.idKey;
		this.d_contextId = this.p_recData[this.p_appEnt.idKey];
      break;
    case "acct":
		this.d_eventOpts = [taskDD, taskAssigned];
		this.d_context = this.p_appEnt.idKey;
		this.d_contextId = this.p_recData[this.p_appEnt.idKey];
      break;
    case "task":
		this.d_eventOpts = [taskDD, taskAssigned];
		this.d_context = this.p_appEnt.idKey;
		this.d_contextId = this.p_recData[this.p_appEnt.idKey];
      break;
    default:
      if (
        this.p_tableName &&
        (/^(|Opportunities|Accounts|Projects)$/.test(this.p_tableName) ||
          /Activities$/.test(this.p_tableName))
      ) {
        this.d_eventOpts = [taskDD, taskAssigned];
      }
	  
	  if(this.p_tableName=='Calendar Activities'){
			this.d_context = 'CalendarTaskId';
			this.d_contextId = null;
			}
  }
  
  
	if (this.p_tableName) {
		this.d_contextId=0;
      switch (this.p_tableName) {
        case "Opportunities":
          this.d_context = "opportunityId";
          break;

        case "Opportunity Activities":
          this.d_context = "opportunityId";
          break;

        case "Projects":
          this.d_context = "projectId";
          break;

        case "Project Activities":
          this.d_context = "projectId";
          break;

        case "Accounts":
          this.d_context = "accountId";
          break;

        case "Account Activities":
          this.d_context = "accountId";
          break;
		}
	}
	
		

	  //if(!this.d_contextId) return;
      fn_getReminderOptions(this.d_context, this.d_contextId).then((resp) => {
        if (resp) {
          this.d_rmndOpt = resp.reminderOptions;

			let events = [];

			
			if(this.d_eventOpts){
			this.d_eventOpts.forEach((e) => {
				let n={};
				
				n=this.d_rmndOpt?this.d_rmndOpt.filter(x => x.triggerKey == e.triggerKey)[0]:{};
				if(n){
					var evnt=Object.assign(e,n);

					events.push(evnt);
					} else {events.push(e);}
				
				});
			}
				this.d_eventOpts=[...events];
				this.d_optsB4 = JSON.stringify(this.d_eventOpts);
				this.$parent.hideHandler = (e) => {};
        } else {
          kbdpAlert.showErr("Unable to read reminder options, Error:" + resp.error);
        }
      });
	

	
	
  },

  mounted() {},
  data() {
    return {
		d_perms: userSettings.permissions,
		d_opts: [],
		d_optsB4: null,
		d_optsGrpd: [],
		d_context: null,
		d_contextId:null,
		d_rmndOpt: null,
		d_eventOpts:[],
    };
  },
  props: {
    p_appEnt: Object,
    p_recData: Object,
    p_rmndOpt: { type: Array, default: () => [] },
    p_tableName: String,
  },
  computed: {
    c_appEntName() {return this.p_tableName ? this.p_tableName : "this " + this.p_appEnt.Name;},
    c_opts() {return this.d_eventOpts.length > 0 ? false : true;},
	c_eventOpts(){return this.d_eventOpts;},
	c_eventOpts1:{
					get:function(){return this.d_eventOpts;},
					set:function(value){console.log(value); this.d_eventOpts=value;}
				}
  },
  methods: {
	m_clickKbdp(id){ 
						if(!this.d_eventOpts[id].disableReminder)
							this.d_eventOpts[id].kbdp=!this.d_eventOpts[id].kbdp;
					},
	m_clickEmail(id){
						if(!this.d_eventOpts[id].disableEmail)
							this.d_eventOpts[id].email=!this.d_eventOpts[id].email;
					},
    m_save() {
      if (this.d_optsB4 != JSON.stringify(this.d_eventOpts)) {
        fn_saveData(this);
      }
      this.$parent.hide();
    },
    m_close() {this.$parent.hide();},
  },
  beforeDestroy() {},
};
function fn_saveData(vc) {
 	
	eventBus.$emit('saved',vc.d_eventOpts);							
  fn_saveReminderOptions(vc.d_context, vc.d_contextId,vc.d_eventOpts).then((resp) => {
    if (resp.upsRecHdr) {
		vc.d_eventOpts.forEach(o=>{
			if(!o.reminderOptionId) 
				o.reminderOptionId=resp.upsRecHdr.filter(u=>u.triggerKey==o.triggerKey)[0].reminderOptionId;
			});
		kbdpAlert.showOk("Reminders and Notifications Saved Successfully");							
    } else {
      kbdpAlert.showErr("Unable to Save Reminders and Notifications");
	}
  });
}

</script>	

<style scoped lang="less">
div.kt-reminder-opts {
	width: 300px;
	border: none;
	border-radius: 6px;
	overflow: hidden;
	background: #fff;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
	div.reminder-opts-header {
		padding: 0.2em 0.4em;
		background-color: #6c757d;
		color: #fff;
		margin-bottom: 0.4em;
		border: none;
	}

	div.reminder-opt-grp {
		> div.opt-grp-hdr {
			padding: 0 0.5em 0.2em 0.5em;
			display: flex;
			flex-wrap: wrap;

			> span.msg {
				width: 100%;
				font-size: 0.9em;
				line-height: 1.1em;
				color: #4fa4ff;
				padding: 0 0.5em;
			}
		}
		&:nth-child(3) > div.opt-grp-hdr {
			cursor: pointer;
			> button {
				width: 20px;
				line-height: 1.1em;
				margin: auto 0;
				margin-right: 0.2em;
			}
			&:hover {
				background-color: #e9ecef;
			}
		}
		> div.opt-grp-hide > span.msg,
		> div.opt-grp-hide ~ div.reminder-opt {
			display: none;
		}
		> div > span.target-others {
			background-color: #f8f9fa;
			border-bottom: solid 0.1em #ced4da;
			line-height: 1em;
			padding-bottom: 0.2em;
		}

		> div > span.days-before {
			font-size: 0.9em;
			padding-left: 0.2em;
		}
		> div > div.event {
			display: flex;
			flex-wrap: nowrap;
			padding: 0.2em;
			// padding-left: 0.4em;

			> div:first-child {
				font-size: 0.9em;
				line-height: 1em;
				flex-grow: 1;
				display: flex;
				> input {
					line-height: 1em;
					padding: 0 0.2em;
					margin-right: 0.4em;
					width: 45px;
					&:focus {
						outline: none;
					}
				}
				> span {
					margin: auto 0;
				}
			}
			> div:last-child {
				flex-shrink: 0;
				white-space: nowrap;
				span {
					display: inline-block;
					// font-size: 0.9em;
					margin: 0 0.4em;
					opacity: 0.5;

					cursor: pointer;
					&:hover {
						opacity: unset;
					}
				}

				span.selected {
					opacity: unset;
					svg:first-child {
						color: #4fa4ff;
						font-size: 1.2em;
					}
					svg.fa-check {
						font-size: 0.8em;
						color: #dc3545;
					}

					&:hover {
						opacity: 0.8;
					}
				}
			}

			&:hover {
				background-color: #f8f9fa;
			}
		}

		> div.reminder-opt {
			display: flex;
			flex-direction: column;
			border: solid 0.1em #adb5bd;
			padding: 0.2em 0.2em;
			margin: 0 0.3em 0.6em 0.3em;
		}

		> div.reminder-opt[disabled] {
			opacity: 0.5;
			pointer-events: none;
		}
	}

	div.reminder-opts-footer {
		padding: 0.5em 0.4em;
		display: flex;

		button {
			font-size: 0.9em;
			padding: 0.1em 0.5em;
			margin: 0 0.2em;
		}
		.tt-info {
			margin-left: auto;
			margin-right: 0.5em;
		}
	}	
}
.selected {
	opacity: unset;
	svg:first-child {
			color: #4fa4ff;
			font-size: 1.2em;
				}
	svg.fa-check {
				font-size: 0.8em;
				color: #dc3545;
                }
				&:hover {
					opacity: 0.8;
						}
	}
.reminder-opts {
		display: flex;
		flex-direction: column;
		border: none; //solid 0.1em #adb5bd;
		margin: 0 0.3em 0.3em 0.3em;
		}
.reminder-opts[disabled] {
		opacity: 0.5;
		pointer-events: none;
		}
hr{margin-top:0;
   margin-bottom:0;
   border:0;
   border-top:solid 0.1em #adb5bd; 
	}
</style>